module.exports = __webpack_public_path__ + "assets/img/slat_close2.a5978c16.svg";